<div class="static-widget" [ngStyle]="setBGStyle()">

  <div class="background-area" [ngStyle]="{ 'background-image' : getBackground(page.image), 'background-position' : getBackgroundPosition() }">
    <div *ngIf="page.description" class="title-wrapper">
      <h4 class="card-static" [ngStyle]="setFontStyle()" [ngClass]="{'largeLabels': page.largeLabels}">{{page.description | i18n}}</h4>
      <h5 class="card-static" [ngStyle]="setFontStyle()" [ngClass]="{'largeDescription': page.largeLabels}">{{page.shortDescription | i18n}}</h5>
    </div>
  </div>
</div>
